import { render, staticRenderFns } from "./EmptyRoute.vue?vue&type=template&id=458c9f02&"
import script from "./EmptyRoute.vue?vue&type=script&lang=ts&"
export * from "./EmptyRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports